app.service('regon', function (modal, select, loading) {

	function nipValidator(nip) {
		var verificator_nip = new Array(6, 5, 7, 2, 3, 4, 5, 6, 7);
		var n = 0;
		var ile;
		for (var i = 0; i < 9; i++) {
			ile = nip.charAt(i) / 1 * verificator_nip[i] / 1;
			n += ile;
		}
		// walidacja odrzuca nip z samymi zerami
		if (n === 0) {
			return false;
		}
		// czy wszystkie cyfry są takie same
		const allDigitsSame = nip.split('').every(digit => digit === nip[0]);
		if (allDigitsSame) {
			return false;
		}
		n %= 11;
		if (n != nip.charAt(9)) {
			return false;
		} else {
			return true;
		}
	}

	function init({ $box, $nip, $companyName, $country, $city, $street, $houseNumber, $flatNumber, $zipCode }) {
		var savedData = {};
		var savedNip;
		if ($box.length && $nip.length) {
			savedNip = $nip.val();
			function check() {
				var nip = $nip.val().replace(/[\ _\-]/gi, "");
				if (nip.length == 10) {
					if (nipValidator(nip)) {
						savedNip = nip;
						return true;
					};
				}
				return false;
			}
			function hide() {
				$box.removeClass('show done');
			}
			function show() {
				$box.addClass('show').removeClass('done');
			}
			function done(json) {
				var $form = $nip.closest('form');
				if ($form.length) {
					if ($companyName.length) {
						if ($companyName.is('input')) {
							$companyName.val(json.companyName).trigger('input');
						} else {// contenteditable
							$companyName.text(json.companyName).trigger('input');
							$form.validate().element($companyName.next());
						}
					}
					if ($city.length) {
						$city.val(json.city);
						$form.validate().element($city);
					}
					if ($street.length) {
						$street.val(json.street);
						$form.validate().element($street);
					}
					if ($houseNumber.length) {
						$houseNumber.val(json.houseNumber);
						$form.validate().element($houseNumber);
					}
					if ($flatNumber.length) {
						$flatNumber.val(json.flatNumber);
						$form.validate().element($flatNumber);
					}
					if ($zipCode.length) {
						$zipCode.val(json.zipCode);
						$form.validate().element($zipCode);
					}
					if ($country.length) {
						if ($country.hasClass("js-customic-select-input")) { // RWD
							select.setValue({ $input: $country, value: 'PL', label: 'Polska' });
						} else { // mobile
							$country.val('PL').trigger('change');
						}
					}
				}
				$box.addClass('done');
			}
			function change($input, name) {
				if ($input.val() != savedData[name]) {
					$box.removeClass('done');
				}
			}
			function showError() {
				modal.generate({
					cssClass: 'regon-loading-error',
					header: 'Rejestr REGON jest niedostępny',
					content: 'Nie udało się pobrać danych na podstawie podanego przez Ciebie numeru NIP. Prosimy spróbuj za chwilę lub wprowadź dane ręcznie.',
				});
			}
			function restore() {
				if ($('#modal-address-box.remodal').length) {
					modal.open('address-box');
				} else if ($('#invoice-form').closest('.remodal').length) {
					modal.open($('#invoice-form').closest('.remodal').attr('id'));
				} else {
					modal.close();
				}
			}

			function load() {
				loading.start();
				/*modal.generate({
					id: 'regon-loading',
					close: false,
					content: 'Pobieramy dane firmy.<br/>Może to zająć chwilę',
					callbackOpen: function () {
						*/
				$.ajax({
					url: '/company-details.ltr?nip=' + savedNip,
					success: function (json) {
						loading.stop();
						if (json.status === 'SUCCESS') {
							//modal.destroy('regon-loading');
							savedData = json;
							done(json);
						} else if (json.status === 'NOT_FOUND') {
							modal.generate({
								id: 'regon-loading-error',
								header: 'Brak danych w rejestrze REGON',
								content: 'Nie udało się pobrać danych na podstawie podanego przez Ciebie numeru NIP. Prosimy wprowadź dane ręcznie.',
								buttons: [{
									text: 'Rozumiem',
									click: function () {
										restore();
									}
								}]
							});
						} else {
							showError();
						}
					}, error: function () {
						loading.stop();
						showError();
					}
				});
				/*}
			});*/
			}
			$('.js-search-regon', $box).on('click', function () {
				load();
			});
			$nip.on('input', function () {
				if (check()) {
					show();
				} else {
					hide();
				}
			});
			$companyName.on('input', function () {
				if ($companyName.text() != savedData['companyName']) {
					$box.removeClass('done');
				}
			});
			$city.on('input', function () {
				change($city, 'city');
			});
			$street.on('input', function () {
				change($street, 'street');
			});
			$houseNumber.on('input', function () {
				change($houseNumber, 'houseNumber');
			})
			$flatNumber.on('input', function () {
				change($flatNumber, 'flatNumber');
			});
			$zipCode.on('input', function () {
				change($zipCode, 'zipCode');
			});
		}
	}
	return {
		init
	};
});